"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefProvider = exports.RefContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
exports.RefContext = (0, react_1.createContext)(null);
var RefProvider = function (_a) {
    var children = _a.children;
    var sharedRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(exports.RefContext.Provider, { value: sharedRef, children: children }));
};
exports.RefProvider = RefProvider;
